import React from 'react';
import { ExternalLink } from 'lucide-react';
import styled from 'styled-components';
import { adsEnabled } from '../../utils/adsEnabled';

const Row = styled.a`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: rgba(0, 48, 135, 0.04);
  border: 1px dashed rgba(0, 48, 135, 0.18);
  text-decoration: none;
  color: inherit;
  transition: background 0.2s;
  &:hover {
    background: rgba(0, 48, 135, 0.08);
  }
`;

const Thumb = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  flex-shrink: 0;
`;

const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Main = styled.div`
  flex: 1;
  min-width: 0;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.125rem;
`;

const AdTag = styled.span`
  padding: 0.125rem 0.375rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: rgba(234, 179, 8, 0.12);
  color: ${({ theme }) => theme.colors.gold};
  font-size: 0.5625rem;
  font-weight: 700;
  text-transform: uppercase;
`;

const Sponsor = styled.span`
  font-size: 0.625rem;
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

const Title = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.foreground};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Desc = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.xs};
  color: ${({ theme }) => theme.colors.mutedForeground};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Cta = styled.span`
  display: none;
  align-items: center;
  gap: 0.25rem;
  padding: 0.375rem 0.75rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
  @media (min-width: 768px) {
    display: inline-flex;
  }
`;

function AdInline({ ad }) {
  if (!adsEnabled()) return null;

  return (
    <Row href={ad.url} target="_blank" rel="noopener noreferrer sponsored">
      <Thumb>
        <ThumbImg src={ad.image} alt={ad.title} loading="lazy" />
      </Thumb>
      <Main>
        <TopRow>
          <AdTag>Ad</AdTag>
          <Sponsor>{ad.sponsor}</Sponsor>
        </TopRow>
        <Title>{ad.title}</Title>
        <Desc>{ad.description}</Desc>
      </Main>
      <Cta>
        {ad.cta} <ExternalLink size={10} />
      </Cta>
    </Row>
  );
}

export default AdInline;
